<template>
  <div>
    <b-modal id="add-room-category-modal" scrollable size="lg">
      <template v-slot:modal-header>
        <h3>{{ trans('prospects.designer.form_add_room_category.administrate_categories') }}</h3>
        <p class="description">
          {{ trans('prospects.designer.form_add_room_category.administrate_categories_description') }}
        </p>
      </template>

      <template v-slot:default>
        <b-container class="full-width">
          <b-table
            id="roomcategories"
            primary-key="catkey"
            hover
            striped
            :items="tableData"
            :fields="tableFields"
            :no-local-sorting="true"
          >
            <template v-slot:head(actions)="row">
              <b-col class="text-right">
                {{ row.label }}
              </b-col>
            </template>
            <template v-slot:cell(name)="row">
              <span v-if="!editCategory[row.item.catkey]">{{ row.item.name }}</span>
              <b-form v-else inline @submit.prevent>
                <b-form-input
                  :ref="'catname-' + row.item.catkey"
                  :value="row.item.name"
                  :v-model="row.item.name"
                  class="form-control-lg"
                  type="text"
                  trim
                ></b-form-input>
                <b-button :ref="'catsubmitbtn-' + row.item.catkey" variant="primary" class="margin-left-8" :style="btnWidth !== 0 ? 'width: ' + btnWidth + 'px;' : ''" @click="updateCatName(row.item.catkey)">
                  <span v-if="!buttonIsLoading[row.item.catkey]">{{ trans('global.save') }}</span>
                  <b-spinner v-else variant="white"></b-spinner>
                </b-button>
                <b-button variant="light" class="margin-left-8" @click="handleCatForm(row.item.catkey, false)">
                  {{ trans('global.cancel') }}
                </b-button>
              </b-form>
            </template>

            <template v-slot:cell(order)="row">
              <b-form inline @submit.prevent>
                <b-form-input :value="row.item.order" class="form-control-lg" type="text" trim @keyup="updateCatOrder(row.item.catkey, $event.target.value)"></b-form-input>
              </b-form>
            </template>

            <template v-slot:cell(icon)="row">
              <b-form inline @submit.prevent>
                <b-form-input :value="row.item.icon" class="form-control-lg" type="text" trim @blur="updateCatIcon(row.item.catkey, $event.target.value)"></b-form-input>
              </b-form>
            </template>

            <template v-slot:cell(type)="row">
              <b-form-select
                :value="row.item.type"
                :options="catTypes"
                class="form-control-lg"
                @change="updateCatType(row.item.catkey, $event)"
              ></b-form-select>
            </template>

            <template v-slot:cell(actions)="row">
              <b-col class="text-right">
                <b-dropdown size="md" variant="primary" no-caret right>
                  <template v-slot:button-content>
                    <i class="fas fa-caret-down"></i>
                  </template>
                  <b-dropdown-item @click="handleCatForm(row.item.catkey, true)">
                    {{ trans('global.edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="openDeleteCategoryModal(row.item.catkey)">
                    {{ trans('global.delete') }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </template>
          </b-table>
          <b-table-simple hover striped>
            <b-tbody v-if="newCategories">
              <b-tr v-for="(category, index) in newCategories" :key="index + '_' + category">
                <b-td>
                  <b-form class="add_category" @submit.prevent>
                    <b-form-input
                      :id="index + '_newCategory'"
                      v-model="newCategories[index].title"
                      :name="index + '_newCategory'"
                      class="form-control-lg margin-right-26"
                      type="text"
                      :placeholder="trans('prospects.designer.form_add_room_category.add_placeholder')"
                      trim
                    ></b-form-input>
                    <b-button variant="primary" side="lg" class="padding-left-26 padding-right-26" @click="saveCategory(index)">
                      {{ trans('global.save') }}
                    </b-button>
                  </b-form>
                </b-td>
              </b-tr>
            </b-tbody>
            <div v-if="showError" class="alert alert-warning margin-top-26">
              <i class="fas fa-exclamation-triangle padding-right-6"></i> {{ trans('prospects.designer.form_add_room_category.no_categories') }}
            </div>
            <b-button variant="primary" size="md" class="padding-left-60 padding-right-60 float-right margin-top-26" @click="addCategory()">
              {{ trans('prospects.designer.form_add_room_category.add') }}
            </b-button>
          </b-table-simple>
        </b-container>
      </template>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="light" size="md" class="padding-left-60 padding-right-60 float-right margin-top-26" @click="cancel()">
          {{ trans('global.close') }}
        </b-button>
      </template>
    </b-modal>
    <ModalDeleteCategory :prospect="prospect" :roomkey="roomkey" :categories="categories !== false ? categories : {}" :categorykey="currentCategoryKey" :roomproducts="roomproducts[roomkey]"></ModalDeleteCategory>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ModalDeleteCategory from './DeleteCategory'

  const fb = require('../../../../../../firebaseConfig')

  export default {
    name: 'ModalAddRoomCategory',
    components: {
      ModalDeleteCategory
    },
    props: {
      prospect: {
        type: Object,
        required: true
      },
      roomkey: {
        type: Number,
        required: true
      },
      roomproducts: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        categoryForm: {
          title: ''
        },
        newCategories: {},
        enabledCategories: [],
        btnLoading: [],
        btnWidth: 0,
        timer: [],
        currentCategoryKey: '',
        catTypes: [
          { value: null, text: 'Vanlig' },
          { value: 1, text: 'Tekst' },
          { value: 2, text: 'Liste' }
        ]
      }
    },
    computed: {
      showError () {
        return !((this.prospect.rooms[this.roomkey].categories !== undefined && Object.keys(this.prospect.rooms[this.roomkey].categories).length > 0) || Object.keys(this.newCategories).length > 0)
      },
      categories () {
        return this.prospect.rooms[this.roomkey].categories !== undefined && Object.keys(this.prospect.rooms[this.roomkey].categories).length > 0 ? this.prospect.rooms[this.roomkey].categories : false
      },
      tableFields () {
        return [
          { key: 'name', label: this.trans('global.name') },
          { key: 'order', label: this.trans('global.order') },
          { key: 'icon', label: this.trans('global.icon') },
          { key: 'type', label: 'Visning' },
          { key: 'actions', label: 'Actions' }
        ]
      },
      tableData () {
        const data = []

        Object.keys(this.categories).map((categoryKey) => {
          if (this.categories[categoryKey].deleted === undefined || this.categories[categoryKey].deleted !== true) {
            data.push({
              catkey: categoryKey,
              name: this.categories[categoryKey].title,
              icon: this.categories[categoryKey].icon !== undefined ? this.categories[categoryKey].icon : '',
              order: this.categories[categoryKey].order !== undefined ? this.categories[categoryKey].order : 0,
              type: this.categories[categoryKey].type !== undefined ? this.categories[categoryKey].type : null
            })
          }
        })

        console.log('DATA:', data)

        return data
      },
      editCategory () {
        const categories = {}

        Object.keys(this.categories).map((categoryKey) => {
          categories[categoryKey] = this.enabledCategories.includes(categoryKey)
        })

        return categories
      },
      buttonIsLoading () {
        const buttons = {}

        Object.keys(this.categories).map((categoryKey) => {
          buttons[categoryKey] = this.btnLoading.includes(categoryKey)
        })

        return buttons
      }
    },
    mounted () {
      this.$root.$on('bv::modal::hide', () => {
        this.newCategories = {}
      })
    },
    methods: {
      addCategory () {
        console.log('Adding category')
        Vue.set(this.newCategories, Object.keys(this.newCategories).length, { title: '' })
      },
      saveCategory (i) {
        const self = this

        const id = this.prospect.rooms[this.roomkey].categories !== undefined ? parseInt(Object.keys(this.prospect.rooms[this.roomkey].categories).pop()) + 1 : 0

        fb.prospectsCollection.doc(this.prospect._id).update({
          [`rooms.${self.roomkey}.categories.${id}`]: {
            createdOn: new Date(),
            title: this.newCategories[i].title,
            userId: self.$store.state.auth.userProfile.uid
          }
        }).then(() => {
          Vue.delete(this.newCategories, i)

          self.$bvToast.toast(self.trans('prospects.designer.form_add_room_category.add_success'), {
            title: self.trans('global.success'),
            variant: 'success',
            solid: true
          })
        }).catch((err) => {
          // Do errorhandling here
          console.log('There was a error while saving the category')
          console.log(err)
        })

        return true
      },
      handleCatForm (id, enable) {
        if (enable) {
          this.enabledCategories.push(id)
        } else {
          this.enabledCategories = this.enabledCategories.filter((item) => {
            return item !== id
          })
        }
      },
      handleCatLoading (id, enable) {
        this.btnWidth = this.$refs['catsubmitbtn-' + id].offsetWidth

        if (enable) {
          this.btnLoading.push(id)
        } else {
          this.btnLoading = this.btnLoading.filter((item) => {
            return item !== id
          })
        }
      },
      updateCatType (catKey, value) {
        const self = this

        if (catKey !== undefined && value !== undefined) {
          fb.prospectsCollection.doc(this.prospect._id).update({
            [`rooms.${self.roomkey}.categories.${catKey}.type`]: value
          }).then(() => {
            this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
              title: this.trans('global.success'),
              variant: 'success',
              solid: true
            })
          }).catch((err) => {
            this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
              title: this.trans('global.error'),
              variant: 'warning',
              solid: true
            })
            console.log(err)
          })
        }
      },
      updateCatName (catKey) {
        const self = this
        const value = this.$refs['catname-' + catKey].localValue

        if (catKey !== undefined && value !== undefined) {
          this.handleCatLoading(catKey, true)
          const updatedId = this.prospect.rooms[this.roomkey].categories[catKey] !== undefined && this.prospect.rooms[this.roomkey].categories[catKey].updated !== undefined && Object.keys(this.prospect.rooms[this.roomkey].categories[catKey].updated).length > 0 ? parseInt(Object.keys(this.prospect.rooms[this.roomkey].categories[catKey].updated).pop()) + 1 : 0

          const updatedInfo = {}
          updatedInfo.userId = self.$store.state.auth.userProfile.uid
          updatedInfo.createdOn = new Date()
          fb.prospectsCollection.doc(this.prospect._id).update({
            [`rooms.${self.roomkey}.categories.${catKey}.title`]: value,
            [`rooms.${self.roomkey}.categories.${catKey}.updated.${updatedId}`]: updatedInfo
          }).then(() => {
            self.$bvToast.toast(self.trans('prospects.designer.form_edit_room_category.update_success'), {
              title: self.trans('global.success'),
              variant: 'success',
              solid: true
            })
            self.handleCatForm(catKey, false)
            self.handleCatLoading(catKey, false)
          }).catch((err) => {
            self.$bvToast.toast(self.trans('prospects.designer.form_edit_room_category.update_error'), {
              title: self.trans('global.error'),
              variant: 'warning',
              solid: true
            })

            console.log(err)

            self.handleCatForm(catKey, false)
            self.handleCatLoading(catKey, false)
          })
        }

        return true
      },
      updateCatOrder (catKey, value) {
        const self = this

        if (catKey !== undefined && value !== undefined) {
          this.inputTimer(catKey).then(() => {
            fb.prospectsCollection.doc(this.prospect._id).update({
              [`rooms.${self.roomkey}.categories.${catKey}.order`]: value
            }).then(() => {
              this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
                title: this.trans('global.success'),
                variant: 'success',
                solid: true
              })
            }).catch((err) => {
              this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
                title: this.trans('global.error'),
                variant: 'warning',
                solid: true
              })
              console.log(err)
            })
          })
        }
      },
      updateCatIcon (catKey, value) {
        console.log('CatIcon:', catKey, value)
        const self = this

        if (catKey !== undefined && value !== undefined && value !== '') {
          this.inputTimer(catKey).then(() => {
            fb.prospectsCollection.doc(this.prospect._id).update({
              [`rooms.${self.roomkey}.categories.${catKey}.icon`]: value
            }).then(() => {
              this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
                title: this.trans('global.success'),
                variant: 'success',
                solid: true
              })
            }).catch((err) => {
              this.$bvToast.toast(this.trans('prospects.designer.product_updated', { product: self.prospect.rooms[self.roomkey].categories[catKey].title }), {
                title: this.trans('global.error'),
                variant: 'warning',
                solid: true
              })
              console.log(err)
            })
          })
        }
      },
      inputTimer (catKey) {
        return new Promise((resolve) => {
          if (this.timer[catKey]) {
            clearTimeout(this.timer[catKey])
            this.timer[catKey] = null
          }

          this.timer[catKey] = setTimeout(() => {
            resolve()
          }, 600)
        })
      },
      openDeleteCategoryModal (catKey) {
        this.currentCategoryKey = catKey
        this.$bvModal.show('delete-category-modal')
      }
      // deleteCategory (catKey) {
      //
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .add_category {
    display: flex;
  }

  #roomcategories {

    /deep/ thead {
      tr {
        th {
          border: none;
        }
      }
    }

    /deep/ tbody {
      tr {
        td {
          vertical-align: middle;
        }
      }
    }
  }
</style>
